module.exports = __webpack_public_path__ + "static/img/image_support_article_cover_01.3c86778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_cover_01.png
// module id = J8by
// module chunks = 10